webpackJsonp([78638645991510],{

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(184)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./react-swipe'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.reactSwipe);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _reactSwipe) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _reactSwipe2 = _interopRequireDefault(_reactSwipe);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _reactSwipe2.default;
	});

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('prop-types'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.propTypes);
	    global.reactSwipe = mod.exports;
	  }
	})(this, function (exports, _react, _propTypes) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.setHasSupportToCaptureOption = setHasSupportToCaptureOption;
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _propTypes2 = _interopRequireDefault(_propTypes);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var supportsCaptureOption = false;
	  function setHasSupportToCaptureOption(hasSupport) {
	    supportsCaptureOption = hasSupport;
	  }
	
	  try {
	    addEventListener('test', null, Object.defineProperty({}, 'capture', { get: function get() {
	        setHasSupportToCaptureOption(true);
	      } }));
	  } catch (e) {} // eslint-disable-line no-empty
	
	  function getSafeEventHandlerOpts() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { capture: true };
	
	    return supportsCaptureOption ? options : options.capture;
	  }
	
	  /**
	   * [getPosition returns a position element that works for mouse or touch events]
	   * @param  {[Event]} event [the received event]
	   * @return {[Object]}      [x and y coords]
	   */
	  function getPosition(event) {
	    if ('touches' in event) {
	      var _event$touches$ = event.touches[0],
	          pageX = _event$touches$.pageX,
	          pageY = _event$touches$.pageY;
	
	      return { x: pageX, y: pageY };
	    }
	
	    var screenX = event.screenX,
	        screenY = event.screenY;
	
	    return { x: screenX, y: screenY };
	  }
	
	  var ReactSwipe = function (_Component) {
	    _inherits(ReactSwipe, _Component);
	
	    function ReactSwipe() {
	      var _ref;
	
	      _classCallCheck(this, ReactSwipe);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var _this = _possibleConstructorReturn(this, (_ref = ReactSwipe.__proto__ || Object.getPrototypeOf(ReactSwipe)).call.apply(_ref, [this].concat(args)));
	
	      _this._handleSwipeStart = _this._handleSwipeStart.bind(_this);
	      _this._handleSwipeMove = _this._handleSwipeMove.bind(_this);
	      _this._handleSwipeEnd = _this._handleSwipeEnd.bind(_this);
	
	      _this._onMouseDown = _this._onMouseDown.bind(_this);
	      _this._onMouseMove = _this._onMouseMove.bind(_this);
	      _this._onMouseUp = _this._onMouseUp.bind(_this);
	
	      _this._setSwiperRef = _this._setSwiperRef.bind(_this);
	      return _this;
	    }
	
	    _createClass(ReactSwipe, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (this.swiper) {
	          this.swiper.addEventListener('touchmove', this._handleSwipeMove, getSafeEventHandlerOpts({
	            capture: true,
	            passive: false
	          }));
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this.swiper) {
	          this.swiper.removeEventListener('touchmove', this._handleSwipeMove, getSafeEventHandlerOpts({
	            capture: true,
	            passive: false
	          }));
	        }
	      }
	    }, {
	      key: '_onMouseDown',
	      value: function _onMouseDown(event) {
	        if (!this.props.allowMouseEvents) {
	          return;
	        }
	
	        this.mouseDown = true;
	
	        document.addEventListener('mouseup', this._onMouseUp);
	        document.addEventListener('mousemove', this._onMouseMove);
	
	        this._handleSwipeStart(event);
	      }
	    }, {
	      key: '_onMouseMove',
	      value: function _onMouseMove(event) {
	        if (!this.mouseDown) {
	          return;
	        }
	
	        this._handleSwipeMove(event);
	      }
	    }, {
	      key: '_onMouseUp',
	      value: function _onMouseUp(event) {
	        this.mouseDown = false;
	
	        document.removeEventListener('mouseup', this._onMouseUp);
	        document.removeEventListener('mousemove', this._onMouseMove);
	
	        this._handleSwipeEnd(event);
	      }
	    }, {
	      key: '_handleSwipeStart',
	      value: function _handleSwipeStart(event) {
	        var _getPosition = getPosition(event),
	            x = _getPosition.x,
	            y = _getPosition.y;
	
	        this.moveStart = { x: x, y: y };
	        this.props.onSwipeStart(event);
	      }
	    }, {
	      key: '_handleSwipeMove',
	      value: function _handleSwipeMove(event) {
	        if (!this.moveStart) {
	          return;
	        }
	
	        var _getPosition2 = getPosition(event),
	            x = _getPosition2.x,
	            y = _getPosition2.y;
	
	        var deltaX = x - this.moveStart.x;
	        var deltaY = y - this.moveStart.y;
	        this.moving = true;
	
	        // handling the responsability of cancelling the scroll to
	        // the component handling the event
	        var shouldPreventDefault = this.props.onSwipeMove({
	          x: deltaX,
	          y: deltaY
	        }, event);
	
	        if (shouldPreventDefault && event.cancelable) {
	          event.preventDefault();
	        }
	
	        this.movePosition = { deltaX: deltaX, deltaY: deltaY };
	      }
	    }, {
	      key: '_handleSwipeEnd',
	      value: function _handleSwipeEnd(event) {
	        this.props.onSwipeEnd(event);
	
	        var tolerance = this.props.tolerance;
	
	
	        if (this.moving && this.movePosition) {
	          if (this.movePosition.deltaX < -tolerance) {
	            this.props.onSwipeLeft(1, event);
	          } else if (this.movePosition.deltaX > tolerance) {
	            this.props.onSwipeRight(1, event);
	          }
	          if (this.movePosition.deltaY < -tolerance) {
	            this.props.onSwipeUp(1, event);
	          } else if (this.movePosition.deltaY > tolerance) {
	            this.props.onSwipeDown(1, event);
	          }
	        }
	
	        this.moveStart = null;
	        this.moving = false;
	        this.movePosition = null;
	      }
	    }, {
	      key: '_setSwiperRef',
	      value: function _setSwiperRef(node) {
	        this.swiper = node;
	        this.props.innerRef(node);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            tagName = _props.tagName,
	            className = _props.className,
	            style = _props.style,
	            children = _props.children,
	            allowMouseEvents = _props.allowMouseEvents,
	            onSwipeUp = _props.onSwipeUp,
	            onSwipeDown = _props.onSwipeDown,
	            onSwipeLeft = _props.onSwipeLeft,
	            onSwipeRight = _props.onSwipeRight,
	            onSwipeStart = _props.onSwipeStart,
	            onSwipeMove = _props.onSwipeMove,
	            onSwipeEnd = _props.onSwipeEnd,
	            innerRef = _props.innerRef,
	            tolerance = _props.tolerance,
	            props = _objectWithoutProperties(_props, ['tagName', 'className', 'style', 'children', 'allowMouseEvents', 'onSwipeUp', 'onSwipeDown', 'onSwipeLeft', 'onSwipeRight', 'onSwipeStart', 'onSwipeMove', 'onSwipeEnd', 'innerRef', 'tolerance']);
	
	        return _react2.default.createElement(
	          this.props.tagName,
	          _extends({
	            ref: this._setSwiperRef,
	            onMouseDown: this._onMouseDown,
	            onTouchStart: this._handleSwipeStart,
	            onTouchEnd: this._handleSwipeEnd,
	            className: className,
	            style: style
	          }, props),
	          children
	        );
	      }
	    }]);
	
	    return ReactSwipe;
	  }(_react.Component);
	
	  ReactSwipe.displayName = 'ReactSwipe';
	  ReactSwipe.propTypes = {
	    tagName: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    style: _propTypes2.default.object,
	    children: _propTypes2.default.node,
	    allowMouseEvents: _propTypes2.default.bool,
	    onSwipeUp: _propTypes2.default.func,
	    onSwipeDown: _propTypes2.default.func,
	    onSwipeLeft: _propTypes2.default.func,
	    onSwipeRight: _propTypes2.default.func,
	    onSwipeStart: _propTypes2.default.func,
	    onSwipeMove: _propTypes2.default.func,
	    onSwipeEnd: _propTypes2.default.func,
	    innerRef: _propTypes2.default.func,
	    tolerance: _propTypes2.default.number.isRequired
	  };
	  ReactSwipe.defaultProps = {
	    tagName: 'div',
	    allowMouseEvents: false,
	    onSwipeUp: function onSwipeUp() {},
	    onSwipeDown: function onSwipeDown() {},
	    onSwipeLeft: function onSwipeLeft() {},
	    onSwipeRight: function onSwipeRight() {},
	    onSwipeStart: function onSwipeStart() {},
	    onSwipeMove: function onSwipeMove() {},
	    onSwipeEnd: function onSwipeEnd() {},
	    innerRef: function innerRef() {},
	
	    tolerance: 0
	  };
	  exports.default = ReactSwipe;
	});

/***/ }),

/***/ 99:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _default = function _default(position, metric, axis) {
	  var positionPercent = position === 0 ? position : position + metric;
	  var positionCss = axis === 'horizontal' ? [positionPercent, 0, 0] : [0, positionPercent, 0];
	  var transitionProp = 'translate3d';
	  var translatedPosition = '(' + positionCss.join(',') + ')';
	  return transitionProp + translatedPosition;
	};
	
	exports.default = _default;

/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(60));
	
	var _reactEasySwipe = _interopRequireDefault(__webpack_require__(98));
	
	var _cssClasses = _interopRequireDefault(__webpack_require__(101));
	
	var _CSSTranslate = _interopRequireDefault(__webpack_require__(99));
	
	var _Thumbs = _interopRequireDefault(__webpack_require__(100));
	
	var _document = _interopRequireDefault(__webpack_require__(189));
	
	var _window = _interopRequireDefault(__webpack_require__(102));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var noop = function noop() {};
	
	var defaultStatusFormatter = function defaultStatusFormatter(current, total) {
	  return "".concat(current, " of ").concat(total);
	};
	
	var isKeyboardEvent = function isKeyboardEvent(e) {
	  return e ? e.hasOwnProperty('key') : false;
	};
	
	var Carousel = /*#__PURE__*/function (_React$Component) {
	  _inherits(Carousel, _React$Component);
	
	  var _super = _createSuper(Carousel);
	
	  function Carousel(props) {
	    var _this;
	
	    _classCallCheck(this, Carousel);
	
	    _this = _super.call(this, props);
	
	    _defineProperty(_assertThisInitialized(_this), "thumbsRef", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "carouselWrapperRef", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "listRef", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "itemsRef", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "timer", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "setThumbsRef", function (node) {
	      _this.thumbsRef = node;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "setCarouselWrapperRef", function (node) {
	      _this.carouselWrapperRef = node;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "setListRef", function (node) {
	      _this.listRef = node;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "setItemsRef", function (node, index) {
	      if (!_this.itemsRef) {
	        _this.itemsRef = [];
	      }
	
	      _this.itemsRef[index] = node;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "autoPlay", function () {
	      if (!_this.state.autoPlay || _react.Children.count(_this.props.children) <= 1) {
	        return;
	      }
	
	      if (_this.timer) clearTimeout(_this.timer);
	      _this.timer = setTimeout(function () {
	        _this.increment();
	      }, _this.props.interval);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "clearAutoPlay", function () {
	      if (!_this.state.autoPlay) {
	        return;
	      }
	
	      if (_this.timer) clearTimeout(_this.timer);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "resetAutoPlay", function () {
	      _this.clearAutoPlay();
	
	      _this.autoPlay();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "stopOnHover", function () {
	      _this.setState({
	        isMouseEntered: true
	      }, _this.clearAutoPlay);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "startOnLeave", function () {
	      _this.setState({
	        isMouseEntered: false
	      }, _this.autoPlay);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "isFocusWithinTheCarousel", function () {
	      if (!_this.carouselWrapperRef) {
	        return false;
	      }
	
	      if ((0, _document.default)().activeElement === _this.carouselWrapperRef || _this.carouselWrapperRef.contains((0, _document.default)().activeElement)) {
	        return true;
	      }
	
	      return false;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "navigateWithKeyboard", function (e) {
	      if (!_this.isFocusWithinTheCarousel()) {
	        return;
	      }
	
	      var axis = _this.props.axis;
	      var isHorizontal = axis === 'horizontal';
	      var keyNames = {
	        ArrowUp: 38,
	        ArrowRight: 39,
	        ArrowDown: 40,
	        ArrowLeft: 37
	      };
	      var nextKey = isHorizontal ? keyNames.ArrowRight : keyNames.ArrowDown;
	      var prevKey = isHorizontal ? keyNames.ArrowLeft : keyNames.ArrowUp;
	
	      if (nextKey === e.keyCode) {
	        _this.increment();
	      } else if (prevKey === e.keyCode) {
	        _this.decrement();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "updateSizes", function () {
	      if (!_this.state.initialized || !_this.itemsRef || _this.itemsRef.length === 0) {
	        return;
	      }
	
	      var isHorizontal = _this.props.axis === 'horizontal';
	      var firstItem = _this.itemsRef[0];
	
	      if (!firstItem) {
	        return;
	      }
	
	      var itemSize = isHorizontal ? firstItem.clientWidth : firstItem.clientHeight;
	
	      _this.setState({
	        itemSize: itemSize
	      });
	
	      if (_this.thumbsRef) {
	        _this.thumbsRef.updateSizes();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "setMountState", function () {
	      _this.setState({
	        hasMount: true
	      });
	
	      _this.updateSizes();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleClickItem", function (index, item) {
	      if (_react.Children.count(_this.props.children) === 0) {
	        return;
	      }
	
	      if (_this.state.cancelClick) {
	        _this.setState({
	          cancelClick: false
	        });
	
	        return;
	      }
	
	      _this.props.onClickItem(index, item);
	
	      if (index !== _this.state.selectedItem) {
	        _this.setState({
	          selectedItem: index
	        });
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (index, item) {
	      if (_react.Children.count(_this.props.children) <= 1) {
	        return;
	      }
	
	      _this.props.onChange(index, item);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleClickThumb", function (index, item) {
	      _this.props.onClickThumb(index, item);
	
	      _this.selectItem({
	        selectedItem: index
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSwipeStart", function (event) {
	      _this.setState({
	        swiping: true
	      });
	
	      _this.props.onSwipeStart(event);
	
	      _this.clearAutoPlay();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSwipeEnd", function (event) {
	      _this.setState({
	        swiping: false,
	        cancelClick: false
	      });
	
	      _this.props.onSwipeEnd(event);
	
	      _this.autoPlay();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSwipeMove", function (delta, event) {
	      _this.props.onSwipeMove(event);
	
	      var isHorizontal = _this.props.axis === 'horizontal';
	
	      var childrenLength = _react.Children.count(_this.props.children);
	
	      var initialBoundry = 0;
	
	      var currentPosition = _this.getPosition(_this.state.selectedItem);
	
	      var finalBoundry = _this.props.infiniteLoop ? _this.getPosition(childrenLength - 1) - 100 : _this.getPosition(childrenLength - 1);
	      var axisDelta = isHorizontal ? delta.x : delta.y;
	      var handledDelta = axisDelta; // prevent user from swiping left out of boundaries
	
	      if (currentPosition === initialBoundry && axisDelta > 0) {
	        handledDelta = 0;
	      } // prevent user from swiping right out of boundaries
	
	
	      if (currentPosition === finalBoundry && axisDelta < 0) {
	        handledDelta = 0;
	      }
	
	      var position = currentPosition + 100 / (_this.state.itemSize / handledDelta);
	
	      var hasMoved = Math.abs(axisDelta) > _this.props.swipeScrollTolerance;
	
	      if (_this.props.infiniteLoop && hasMoved) {
	        // When allowing infinite loop, if we slide left from position 0 we reveal the cloned last slide that appears before it
	        // if we slide even further we need to jump to other side so it can continue - and vice versa for the last slide
	        if (_this.state.selectedItem === 0 && position > -100) {
	          position -= childrenLength * 100;
	        } else if (_this.state.selectedItem === childrenLength - 1 && position < -childrenLength * 100) {
	          position += childrenLength * 100;
	        }
	      }
	
	      if (!_this.props.preventMovementUntilSwipeScrollTolerance || hasMoved) {
	        _this.setPosition(position);
	      } // allows scroll if the swipe was within the tolerance
	
	
	      if (hasMoved && !_this.state.cancelClick) {
	        _this.setState({
	          cancelClick: true
	        });
	      }
	
	      return hasMoved;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "setPosition", function (position, forceReflow) {
	      var list = _reactDom.default.findDOMNode(_this.listRef);
	
	      if (list instanceof HTMLElement) {
	        ['WebkitTransform', 'MozTransform', 'MsTransform', 'OTransform', 'transform', 'msTransform'].forEach(function (prop) {
	          list.style[prop] = (0, _CSSTranslate.default)(position, '%', _this.props.axis);
	        });
	
	        if (forceReflow) {
	          list.offsetLeft;
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "resetPosition", function () {
	      var currentPosition = _this.getPosition(_this.state.selectedItem);
	
	      _this.setPosition(currentPosition);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "decrement", function () {
	      var positions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var fromSwipe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      _this.moveTo(_this.state.selectedItem - (typeof positions === 'number' ? positions : 1), fromSwipe);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "increment", function () {
	      var positions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var fromSwipe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      _this.moveTo(_this.state.selectedItem + (typeof positions === 'number' ? positions : 1), fromSwipe);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "moveTo", function (position, fromSwipe) {
	      if (typeof position !== 'number') {
	        return;
	      }
	
	      var lastPosition = _react.Children.count(_this.props.children) - 1;
	      var needClonedSlide = _this.props.infiniteLoop && !fromSwipe && (position < 0 || position > lastPosition);
	      var oldPosition = position;
	
	      if (position < 0) {
	        position = _this.props.infiniteLoop ? lastPosition : 0;
	      }
	
	      if (position > lastPosition) {
	        position = _this.props.infiniteLoop ? 0 : lastPosition;
	      }
	
	      if (needClonedSlide) {
	        // set swiping true would disable transition time, then we set slider to cloned position and force a reflow
	        // this is only needed for non-swiping situation
	        _this.setState({
	          swiping: true
	        }, function () {
	          if (oldPosition < 0) {
	            if (_this.props.centerMode && _this.props.centerSlidePercentage && _this.props.axis === 'horizontal') {
	              _this.setPosition(-(lastPosition + 2) * _this.props.centerSlidePercentage - (100 - _this.props.centerSlidePercentage) / 2, true);
	            } else {
	              _this.setPosition(-(lastPosition + 2) * 100, true);
	            }
	          } else if (oldPosition > lastPosition) {
	            _this.setPosition(0, true);
	          }
	
	          _this.selectItem({
	            selectedItem: position,
	            swiping: false
	          });
	        });
	      } else {
	        _this.selectItem({
	          // if it's not a slider, we don't need to set position here
	          selectedItem: position
	        });
	      } // don't reset auto play when stop on hover is enabled, doing so will trigger a call to auto play more than once
	      // and will result in the interval function not being cleared correctly.
	
	
	      if (_this.state.autoPlay && _this.state.isMouseEntered === false) {
	        _this.resetAutoPlay();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onClickNext", function () {
	      _this.increment(1, false);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onClickPrev", function () {
	      _this.decrement(1, false);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSwipeForward", function () {
	      _this.increment(1, true);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSwipeBackwards", function () {
	      _this.decrement(1, true);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "changeItem", function (newIndex) {
	      return function (e) {
	        if (!isKeyboardEvent(e) || e.key === 'Enter') {
	          _this.selectItem({
	            selectedItem: newIndex
	          });
	        }
	      };
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "selectItem", function (state, cb) {
	      _this.setState(state, cb);
	
	      _this.handleOnChange(state.selectedItem, _react.Children.toArray(_this.props.children)[state.selectedItem]);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "getInitialImage", function () {
	      var selectedItem = _this.props.selectedItem;
	      var item = _this.itemsRef && _this.itemsRef[selectedItem];
	      var images = item && item.getElementsByTagName('img') || [];
	      return images[0];
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "getVariableItemHeight", function (position) {
	      var item = _this.itemsRef && _this.itemsRef[position];
	
	      if (_this.state.hasMount && item && item.children.length) {
	        var slideImages = item.children[0].getElementsByTagName('img') || [];
	
	        if (slideImages.length > 0) {
	          var image = slideImages[0];
	
	          if (!image.complete) {
	            // if the image is still loading, the size won't be available so we trigger a new render after it's done
	            var onImageLoad = function onImageLoad() {
	              _this.forceUpdate();
	
	              image.removeEventListener('load', onImageLoad);
	            };
	
	            image.addEventListener('load', onImageLoad);
	          }
	        }
	
	        var height = item.children[0].clientHeight;
	        return height > 0 ? height : null;
	      }
	
	      return null;
	    });
	
	    _this.state = {
	      initialized: false,
	      selectedItem: props.selectedItem,
	      hasMount: false,
	      isMouseEntered: false,
	      autoPlay: props.autoPlay,
	      swiping: false,
	      cancelClick: false,
	      itemSize: 1
	    };
	    return _this;
	  }
	
	  _createClass(Carousel, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (!this.props.children) {
	        return;
	      }
	
	      this.setupCarousel();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (!prevProps.children && this.props.children && !this.state.initialized) {
	        this.setupCarousel();
	      }
	
	      if (prevState.swiping && !this.state.swiping) {
	        // We stopped swiping, ensure we are heading to the new/current slide and not stuck
	        this.resetPosition();
	      }
	
	      if (prevProps.selectedItem !== this.props.selectedItem || prevProps.centerMode !== this.props.centerMode) {
	        this.updateSizes();
	        this.moveTo(this.props.selectedItem);
	      }
	
	      if (prevProps.autoPlay !== this.props.autoPlay) {
	        if (this.props.autoPlay) {
	          this.setupAutoPlay();
	        } else {
	          this.destroyAutoPlay();
	        }
	
	        this.setState({
	          autoPlay: this.props.autoPlay
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.destroyCarousel();
	    }
	  }, {
	    key: "setupCarousel",
	    value: function setupCarousel() {
	      var _this2 = this;
	
	      this.bindEvents();
	
	      if (this.state.autoPlay && _react.Children.count(this.props.children) > 1) {
	        this.setupAutoPlay();
	      }
	
	      this.setState({
	        initialized: true
	      }, function () {
	        var initialImage = _this2.getInitialImage();
	
	        if (initialImage && !initialImage.complete) {
	          // if it's a carousel of images, we set the mount state after the first image is loaded
	          initialImage.addEventListener('load', _this2.setMountState);
	        } else {
	          _this2.setMountState();
	        }
	      });
	    }
	  }, {
	    key: "destroyCarousel",
	    value: function destroyCarousel() {
	      if (this.state.initialized) {
	        this.unbindEvents();
	        this.destroyAutoPlay();
	      }
	    }
	  }, {
	    key: "setupAutoPlay",
	    value: function setupAutoPlay() {
	      this.autoPlay();
	      var carouselWrapper = this.carouselWrapperRef;
	
	      if (this.props.stopOnHover && carouselWrapper) {
	        carouselWrapper.addEventListener('mouseenter', this.stopOnHover);
	        carouselWrapper.addEventListener('mouseleave', this.startOnLeave);
	      }
	    }
	  }, {
	    key: "destroyAutoPlay",
	    value: function destroyAutoPlay() {
	      this.clearAutoPlay();
	      var carouselWrapper = this.carouselWrapperRef;
	
	      if (this.props.stopOnHover && carouselWrapper) {
	        carouselWrapper.removeEventListener('mouseenter', this.stopOnHover);
	        carouselWrapper.removeEventListener('mouseleave', this.startOnLeave);
	      }
	    }
	  }, {
	    key: "bindEvents",
	    value: function bindEvents() {
	      // as the widths are calculated, we need to resize
	      // the carousel when the window is resized
	      (0, _window.default)().addEventListener('resize', this.updateSizes); // issue #2 - image loading smaller
	
	      (0, _window.default)().addEventListener('DOMContentLoaded', this.updateSizes);
	
	      if (this.props.useKeyboardArrows) {
	        (0, _document.default)().addEventListener('keydown', this.navigateWithKeyboard);
	      }
	    }
	  }, {
	    key: "unbindEvents",
	    value: function unbindEvents() {
	      // removing listeners
	      (0, _window.default)().removeEventListener('resize', this.updateSizes);
	      (0, _window.default)().removeEventListener('DOMContentLoaded', this.updateSizes);
	      var initialImage = this.getInitialImage();
	
	      if (initialImage) {
	        initialImage.removeEventListener('load', this.setMountState);
	      }
	
	      if (this.props.useKeyboardArrows) {
	        (0, _document.default)().removeEventListener('keydown', this.navigateWithKeyboard);
	      }
	    }
	  }, {
	    key: "getPosition",
	    value: function getPosition(index) {
	      if (this.props.infiniteLoop) {
	        // index has to be added by 1 because of the first cloned slide
	        ++index;
	      }
	
	      if (index === 0) {
	        return 0;
	      }
	
	      var childrenLength = _react.Children.count(this.props.children);
	
	      if (this.props.centerMode && this.props.axis === 'horizontal') {
	        var currentPosition = -index * this.props.centerSlidePercentage;
	        var lastPosition = childrenLength - 1;
	
	        if (index && (index !== lastPosition || this.props.infiniteLoop)) {
	          currentPosition += (100 - this.props.centerSlidePercentage) / 2;
	        } else if (index === lastPosition) {
	          currentPosition += 100 - this.props.centerSlidePercentage;
	        }
	
	        return currentPosition;
	      }
	
	      return -index * 100;
	    }
	  }, {
	    key: "renderItems",
	    value: function renderItems(isClone) {
	      var _this3 = this;
	
	      if (!this.props.children) {
	        return [];
	      }
	
	      return _react.Children.map(this.props.children, function (item, index) {
	        var slideProps = {
	          ref: function ref(e) {
	            return _this3.setItemsRef(e, index);
	          },
	          key: 'itemKey' + index + (isClone ? 'clone' : ''),
	          className: _cssClasses.default.ITEM(true, index === _this3.state.selectedItem),
	          onClick: _this3.handleClickItem.bind(_this3, index, item)
	        };
	        var extraProps = {};
	
	        if (_this3.props.centerMode && _this3.props.axis === 'horizontal') {
	          extraProps.style = {
	            minWidth: _this3.props.centerSlidePercentage + '%'
	          };
	        }
	
	        return /*#__PURE__*/_react.default.createElement("li", _extends({}, slideProps, extraProps), _this3.props.renderItem(item, {
	          isSelected: index === _this3.state.selectedItem
	        }));
	      });
	    }
	  }, {
	    key: "renderControls",
	    value: function renderControls() {
	      var _this4 = this;
	
	      var _this$props = this.props,
	          showIndicators = _this$props.showIndicators,
	          labels = _this$props.labels,
	          renderIndicator = _this$props.renderIndicator,
	          children = _this$props.children;
	
	      if (!showIndicators) {
	        return null;
	      }
	
	      return /*#__PURE__*/_react.default.createElement("ul", {
	        className: "control-dots"
	      }, _react.Children.map(children, function (_, index) {
	        return renderIndicator && renderIndicator(_this4.changeItem(index), index === _this4.state.selectedItem, index, labels.item);
	      }));
	    }
	  }, {
	    key: "renderStatus",
	    value: function renderStatus() {
	      if (!this.props.showStatus) {
	        return null;
	      }
	
	      return /*#__PURE__*/_react.default.createElement("p", {
	        className: "carousel-status"
	      }, this.props.statusFormatter(this.state.selectedItem + 1, _react.Children.count(this.props.children)));
	    }
	  }, {
	    key: "renderThumbs",
	    value: function renderThumbs() {
	      if (!this.props.showThumbs || !this.props.children || _react.Children.count(this.props.children) === 0) {
	        return null;
	      }
	
	      return /*#__PURE__*/_react.default.createElement(_Thumbs.default, {
	        ref: this.setThumbsRef,
	        onSelectItem: this.handleClickThumb,
	        selectedItem: this.state.selectedItem,
	        transitionTime: this.props.transitionTime,
	        thumbWidth: this.props.thumbWidth,
	        labels: this.props.labels
	      }, this.props.renderThumbs(this.props.children));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this5 = this;
	
	      if (!this.props.children || _react.Children.count(this.props.children) === 0) {
	        return null;
	      }
	
	      var isHorizontal = this.props.axis === 'horizontal';
	      var canShowArrows = this.props.showArrows && _react.Children.count(this.props.children) > 1; // show left arrow?
	
	      var hasPrev = canShowArrows && (this.state.selectedItem > 0 || this.props.infiniteLoop) || false; // show right arrow
	
	      var hasNext = canShowArrows && (this.state.selectedItem < _react.Children.count(this.props.children) - 1 || this.props.infiniteLoop) || false; // obj to hold the transformations and styles
	
	      var itemListStyles = {};
	      var currentPosition = this.getPosition(this.state.selectedItem); // if 3d is available, let's take advantage of the performance of transform
	
	      var transformProp = (0, _CSSTranslate.default)(currentPosition, '%', this.props.axis);
	      var transitionTime = this.props.transitionTime + 'ms';
	      itemListStyles = {
	        WebkitTransform: transformProp,
	        MozTransform: transformProp,
	        MsTransform: transformProp,
	        OTransform: transformProp,
	        transform: transformProp,
	        msTransform: transformProp
	      };
	
	      if (!this.state.swiping) {
	        itemListStyles = _objectSpread(_objectSpread({}, itemListStyles), {}, {
	          WebkitTransitionDuration: transitionTime,
	          MozTransitionDuration: transitionTime,
	          MsTransitionDuration: transitionTime,
	          OTransitionDuration: transitionTime,
	          transitionDuration: transitionTime,
	          msTransitionDuration: transitionTime
	        });
	      }
	
	      var itemsClone = this.renderItems(true);
	      var firstClone = itemsClone.shift();
	      var lastClone = itemsClone.pop();
	      var swiperProps = {
	        className: _cssClasses.default.SLIDER(true, this.state.swiping),
	        onSwipeMove: this.onSwipeMove,
	        onSwipeStart: this.onSwipeStart,
	        onSwipeEnd: this.onSwipeEnd,
	        style: itemListStyles,
	        tolerance: this.props.swipeScrollTolerance
	      };
	      var containerStyles = {};
	
	      if (isHorizontal) {
	        swiperProps.onSwipeLeft = this.onSwipeForward;
	        swiperProps.onSwipeRight = this.onSwipeBackwards;
	
	        if (this.props.dynamicHeight) {
	          var itemHeight = this.getVariableItemHeight(this.state.selectedItem);
	          swiperProps.style.height = itemHeight || 'auto';
	          containerStyles.height = itemHeight || 'auto';
	        }
	      } else {
	        swiperProps.onSwipeUp = this.props.verticalSwipe === 'natural' ? this.onSwipeBackwards : this.onSwipeForward;
	        swiperProps.onSwipeDown = this.props.verticalSwipe === 'natural' ? this.onSwipeForward : this.onSwipeBackwards;
	        swiperProps.style.height = this.state.itemSize;
	        containerStyles.height = this.state.itemSize;
	      }
	
	      return /*#__PURE__*/_react.default.createElement("div", {
	        className: _cssClasses.default.ROOT(this.props.className),
	        ref: this.setCarouselWrapperRef,
	        tabIndex: 0
	      }, /*#__PURE__*/_react.default.createElement("div", {
	        className: _cssClasses.default.CAROUSEL(true),
	        style: {
	          width: this.props.width
	        }
	      }, this.props.renderArrowPrev(this.onClickPrev, hasPrev, this.props.labels.leftArrow), /*#__PURE__*/_react.default.createElement("div", {
	        className: _cssClasses.default.WRAPPER(true, this.props.axis),
	        style: containerStyles
	      }, this.props.swipeable ? /*#__PURE__*/_react.default.createElement(_reactEasySwipe.default, _extends({
	        tagName: "ul",
	        innerRef: this.setListRef
	      }, swiperProps, {
	        allowMouseEvents: this.props.emulateTouch
	      }), this.props.infiniteLoop && lastClone, this.renderItems(), this.props.infiniteLoop && firstClone) : /*#__PURE__*/_react.default.createElement("ul", {
	        className: _cssClasses.default.SLIDER(true, this.state.swiping),
	        ref: function ref(node) {
	          return _this5.setListRef(node);
	        },
	        style: itemListStyles
	      }, this.props.infiniteLoop && lastClone, this.renderItems(), this.props.infiniteLoop && firstClone)), this.props.renderArrowNext(this.onClickNext, hasNext, this.props.labels.rightArrow), this.renderControls(), this.renderStatus()), this.renderThumbs());
	    }
	  }]);
	
	  return Carousel;
	}(_react.default.Component);
	
	exports.default = Carousel;
	
	_defineProperty(Carousel, "displayName", 'Carousel');
	
	_defineProperty(Carousel, "defaultProps", {
	  axis: 'horizontal',
	  centerSlidePercentage: 80,
	  interval: 3000,
	  labels: {
	    leftArrow: 'previous slide / item',
	    rightArrow: 'next slide / item',
	    item: 'slide item'
	  },
	  onClickItem: noop,
	  onClickThumb: noop,
	  onChange: noop,
	  onSwipeStart: function onSwipeStart() {},
	  onSwipeEnd: function onSwipeEnd() {},
	  onSwipeMove: function onSwipeMove() {},
	  preventMovementUntilSwipeScrollTolerance: false,
	  renderArrowPrev: function renderArrowPrev(onClickHandler, hasPrev, label) {
	    return /*#__PURE__*/_react.default.createElement("button", {
	      type: "button",
	      "aria-label": label,
	      className: _cssClasses.default.ARROW_PREV(!hasPrev),
	      onClick: onClickHandler
	    });
	  },
	  renderArrowNext: function renderArrowNext(onClickHandler, hasNext, label) {
	    return /*#__PURE__*/_react.default.createElement("button", {
	      type: "button",
	      "aria-label": label,
	      className: _cssClasses.default.ARROW_NEXT(!hasNext),
	      onClick: onClickHandler
	    });
	  },
	  renderIndicator: function renderIndicator(onClickHandler, isSelected, index, label) {
	    return /*#__PURE__*/_react.default.createElement("li", {
	      className: _cssClasses.default.DOT(isSelected),
	      onClick: onClickHandler,
	      onKeyDown: onClickHandler,
	      value: index,
	      key: index,
	      role: "button",
	      tabIndex: 0,
	      "aria-label": "".concat(label, " ").concat(index + 1)
	    });
	  },
	  renderItem: function renderItem(item) {
	    return item;
	  },
	  renderThumbs: function renderThumbs(children) {
	    var images = _react.Children.map(children, function (item) {
	      var img = item; // if the item is not an image, try to find the first image in the item's children.
	
	      if (item.type !== 'img') {
	        img = _react.Children.toArray(item.props.children).find(function (children) {
	          return children.type === 'img';
	        });
	      }
	
	      if (!img) {
	        return undefined;
	      }
	
	      return img;
	    });
	
	    if (images.filter(function (image) {
	      return image;
	    }).length === 0) {
	      console.warn("No images found! Can't build the thumb list without images. If you don't need thumbs, set showThumbs={false} in the Carousel. Note that it's not possible to get images rendered inside custom components. More info at https://github.com/leandrowd/react-responsive-carousel/blob/master/TROUBLESHOOTING.md");
	      return [];
	    }
	
	    return images;
	  },
	  statusFormatter: defaultStatusFormatter,
	  selectedItem: 0,
	  showArrows: true,
	  showIndicators: true,
	  showStatus: true,
	  showThumbs: true,
	  stopOnHover: true,
	  swipeScrollTolerance: 5,
	  swipeable: true,
	  transitionTime: 350,
	  verticalSwipe: 'standard',
	  width: '100%'
	});

/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _cssClasses = _interopRequireDefault(__webpack_require__(101));
	
	var _dimensions = __webpack_require__(187);
	
	var _CSSTranslate = _interopRequireDefault(__webpack_require__(99));
	
	var _reactEasySwipe = _interopRequireDefault(__webpack_require__(98));
	
	var _window = _interopRequireDefault(__webpack_require__(102));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var isKeyboardEvent = function isKeyboardEvent(e) {
	  return e.hasOwnProperty('key');
	};
	
	var Thumbs = /*#__PURE__*/function (_Component) {
	  _inherits(Thumbs, _Component);
	
	  var _super = _createSuper(Thumbs);
	
	  function Thumbs(_props) {
	    var _this;
	
	    _classCallCheck(this, Thumbs);
	
	    _this = _super.call(this, _props);
	
	    _defineProperty(_assertThisInitialized(_this), "itemsWrapperRef", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "itemsListRef", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "thumbsRef", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "setItemsWrapperRef", function (node) {
	      _this.itemsWrapperRef = node;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "setItemsListRef", function (node) {
	      _this.itemsListRef = node;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "setThumbsRef", function (node, index) {
	      if (!_this.thumbsRef) {
	        _this.thumbsRef = [];
	      }
	
	      _this.thumbsRef[index] = node;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "updateSizes", function () {
	      if (!_this.props.children || !_this.itemsWrapperRef || !_this.thumbsRef) {
	        return;
	      }
	
	      var total = _react.Children.count(_this.props.children);
	
	      var wrapperSize = _this.itemsWrapperRef.clientWidth;
	      var itemSize = _this.props.thumbWidth ? _this.props.thumbWidth : (0, _dimensions.outerWidth)(_this.thumbsRef[0]);
	      var visibleItems = Math.floor(wrapperSize / itemSize);
	      var lastPosition = total - visibleItems;
	      var showArrows = visibleItems < total;
	
	      _this.setState(function (_state, props) {
	        return {
	          itemSize: itemSize,
	          visibleItems: visibleItems,
	          firstItem: showArrows ? _this.getFirstItem(props.selectedItem) : 0,
	          lastPosition: lastPosition,
	          showArrows: showArrows
	        };
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleClickItem", function (index, item, e) {
	      if (!isKeyboardEvent(e) || e.key === 'Enter') {
	        var handler = _this.props.onSelectItem;
	
	        if (typeof handler === 'function') {
	          handler(index, item);
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSwipeStart", function () {
	      _this.setState({
	        swiping: true
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSwipeEnd", function () {
	      _this.setState({
	        swiping: false
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSwipeMove", function (delta) {
	      var deltaX = delta.x;
	
	      if (!_this.state.itemSize || !_this.itemsWrapperRef) {
	        return false;
	      }
	
	      var leftBoundary = 0;
	      var currentPosition = -_this.state.firstItem * _this.state.itemSize;
	      var lastLeftBoundary = -_this.state.visibleItems * _this.state.itemSize; // prevent user from swiping left out of boundaries
	
	      if (currentPosition === leftBoundary && deltaX > 0) {
	        deltaX = 0;
	      } // prevent user from swiping right out of boundaries
	
	
	      if (currentPosition === lastLeftBoundary && deltaX < 0) {
	        deltaX = 0;
	      }
	
	      var wrapperSize = _this.itemsWrapperRef.clientWidth;
	      var position = currentPosition + 100 / (wrapperSize / deltaX); // if 3d isn't available we will use left to move
	
	      if (_this.itemsListRef) {
	        ['WebkitTransform', 'MozTransform', 'MsTransform', 'OTransform', 'transform', 'msTransform'].forEach(function (prop) {
	          _this.itemsListRef.style[prop] = (0, _CSSTranslate.default)(position, '%', _this.props.axis);
	        });
	      }
	
	      return true;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slideRight", function (positions) {
	      _this.moveTo(_this.state.firstItem - (typeof positions === 'number' ? positions : 1));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slideLeft", function (positions) {
	      _this.moveTo(_this.state.firstItem + (typeof positions === 'number' ? positions : 1));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "moveTo", function (position) {
	      // position can't be lower than 0
	      position = position < 0 ? 0 : position; // position can't be higher than last postion
	
	      position = position >= _this.state.lastPosition ? _this.state.lastPosition : position;
	
	      _this.setState({
	        firstItem: position
	      });
	    });
	
	    _this.state = {
	      selectedItem: _props.selectedItem,
	      swiping: false,
	      showArrows: false,
	      firstItem: 0,
	      visibleItems: 0,
	      lastPosition: 0
	    };
	    return _this;
	  }
	
	  _createClass(Thumbs, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setupThumbs();
	    }
	  }, {
	    key: "UNSAFE_componentWillReceiveProps",
	    value: function UNSAFE_componentWillReceiveProps(props) {
	      if (props.selectedItem !== this.state.selectedItem) {
	        this.setState({
	          selectedItem: props.selectedItem,
	          firstItem: this.getFirstItem(props.selectedItem)
	        });
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.children === prevProps.children) {
	        return;
	      } // This will capture any size changes for arrow adjustments etc.
	      // usually in the same render cycle so we don't see any flickers
	
	
	      this.updateSizes();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.destroyThumbs();
	    }
	  }, {
	    key: "setupThumbs",
	    value: function setupThumbs() {
	      // as the widths are calculated, we need to resize
	      // the carousel when the window is resized
	      (0, _window.default)().addEventListener('resize', this.updateSizes); // issue #2 - image loading smaller
	
	      (0, _window.default)().addEventListener('DOMContentLoaded', this.updateSizes); // when the component is rendered we need to calculate
	      // the container size to adjust the responsive behaviour
	
	      this.updateSizes();
	    }
	  }, {
	    key: "destroyThumbs",
	    value: function destroyThumbs() {
	      // removing listeners
	      (0, _window.default)().removeEventListener('resize', this.updateSizes);
	      (0, _window.default)().removeEventListener('DOMContentLoaded', this.updateSizes);
	    }
	  }, {
	    key: "getFirstItem",
	    value: function getFirstItem(selectedItem) {
	      var firstItem = selectedItem;
	
	      if (selectedItem >= this.state.lastPosition) {
	        firstItem = this.state.lastPosition;
	      }
	
	      if (selectedItem < this.state.firstItem + this.state.visibleItems) {
	        firstItem = this.state.firstItem;
	      }
	
	      if (selectedItem < this.state.firstItem) {
	        firstItem = selectedItem;
	      }
	
	      return firstItem;
	    }
	  }, {
	    key: "renderItems",
	    value: function renderItems() {
	      var _this2 = this;
	
	      return this.props.children.map(function (img, index) {
	        var itemClass = _cssClasses.default.ITEM(false, index === _this2.state.selectedItem);
	
	        var thumbProps = {
	          key: index,
	          ref: function ref(e) {
	            return _this2.setThumbsRef(e, index);
	          },
	          className: itemClass,
	          onClick: _this2.handleClickItem.bind(_this2, index, _this2.props.children[index]),
	          onKeyDown: _this2.handleClickItem.bind(_this2, index, _this2.props.children[index]),
	          'aria-label': "".concat(_this2.props.labels.item, " ").concat(index + 1),
	          style: {
	            width: _this2.props.thumbWidth
	          }
	        };
	        return /*#__PURE__*/_react.default.createElement("li", _extends({}, thumbProps, {
	          role: "button",
	          tabIndex: 0
	        }), img);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      if (!this.props.children) {
	        return null;
	      } // show left arrow?
	
	
	      var hasPrev = this.state.showArrows && this.state.firstItem > 0; // show right arrow
	
	      var hasNext = this.state.showArrows && this.state.firstItem < this.state.lastPosition; // obj to hold the transformations and styles
	
	      var itemListStyles = {};
	      var currentPosition = -this.state.firstItem * (this.state.itemSize || 0);
	      var transformProp = (0, _CSSTranslate.default)(currentPosition, 'px', this.props.axis);
	      var transitionTime = this.props.transitionTime + 'ms';
	      itemListStyles = {
	        WebkitTransform: transformProp,
	        MozTransform: transformProp,
	        MsTransform: transformProp,
	        OTransform: transformProp,
	        transform: transformProp,
	        msTransform: transformProp,
	        WebkitTransitionDuration: transitionTime,
	        MozTransitionDuration: transitionTime,
	        MsTransitionDuration: transitionTime,
	        OTransitionDuration: transitionTime,
	        transitionDuration: transitionTime,
	        msTransitionDuration: transitionTime
	      };
	      return /*#__PURE__*/_react.default.createElement("div", {
	        className: _cssClasses.default.CAROUSEL(false)
	      }, /*#__PURE__*/_react.default.createElement("div", {
	        className: _cssClasses.default.WRAPPER(false),
	        ref: this.setItemsWrapperRef
	      }, /*#__PURE__*/_react.default.createElement("button", {
	        type: "button",
	        className: _cssClasses.default.ARROW_PREV(!hasPrev),
	        onClick: function onClick() {
	          return _this3.slideRight();
	        },
	        "aria-label": this.props.labels.leftArrow
	      }), /*#__PURE__*/_react.default.createElement(_reactEasySwipe.default, {
	        tagName: "ul",
	        className: _cssClasses.default.SLIDER(false, this.state.swiping),
	        onSwipeLeft: this.slideLeft,
	        onSwipeRight: this.slideRight,
	        onSwipeMove: this.onSwipeMove,
	        onSwipeStart: this.onSwipeStart,
	        onSwipeEnd: this.onSwipeEnd,
	        style: itemListStyles,
	        innerRef: this.setItemsListRef
	      }, this.renderItems()), /*#__PURE__*/_react.default.createElement("button", {
	        type: "button",
	        className: _cssClasses.default.ARROW_NEXT(!hasNext),
	        onClick: function onClick() {
	          return _this3.slideLeft();
	        },
	        "aria-label": this.props.labels.rightArrow
	      })));
	    }
	  }]);
	
	  return Thumbs;
	}(_react.Component);
	
	exports.default = Thumbs;
	
	_defineProperty(Thumbs, "displayName", 'Thumbs');
	
	_defineProperty(Thumbs, "defaultProps", {
	  axis: 'horizontal',
	  labels: {
	    leftArrow: 'previous slide / item',
	    rightArrow: 'next slide / item',
	    item: 'slide item'
	  },
	  selectedItem: 0,
	  thumbWidth: 80,
	  transitionTime: 350
	});

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classnames = _interopRequireDefault(__webpack_require__(136));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _default = {
	  ROOT: function ROOT(customClassName) {
	    return (0, _classnames.default)(_defineProperty({
	      'carousel-root': true
	    }, customClassName || '', !!customClassName));
	  },
	  CAROUSEL: function CAROUSEL(isSlider) {
	    return (0, _classnames.default)({
	      carousel: true,
	      'carousel-slider': isSlider
	    });
	  },
	  WRAPPER: function WRAPPER(isSlider, axis) {
	    return (0, _classnames.default)({
	      'thumbs-wrapper': !isSlider,
	      'slider-wrapper': isSlider,
	      'axis-horizontal': axis === 'horizontal',
	      'axis-vertical': axis !== 'horizontal'
	    });
	  },
	  SLIDER: function SLIDER(isSlider, isSwiping) {
	    return (0, _classnames.default)({
	      thumbs: !isSlider,
	      slider: isSlider,
	      animated: !isSwiping
	    });
	  },
	  ITEM: function ITEM(isSlider, selected) {
	    return (0, _classnames.default)({
	      thumb: !isSlider,
	      slide: isSlider,
	      selected: selected
	    });
	  },
	  ARROW_PREV: function ARROW_PREV(disabled) {
	    return (0, _classnames.default)({
	      'control-arrow control-prev': true,
	      'control-disabled': disabled
	    });
	  },
	  ARROW_NEXT: function ARROW_NEXT(disabled) {
	    return (0, _classnames.default)({
	      'control-arrow control-next': true,
	      'control-disabled': disabled
	    });
	  },
	  DOT: function DOT(selected) {
	    return (0, _classnames.default)({
	      dot: true,
	      selected: selected
	    });
	  }
	};
	exports.default = _default;

/***/ }),

/***/ 187:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.outerWidth = void 0;
	
	var outerWidth = function outerWidth(el) {
	  var width = el.offsetWidth;
	  var style = getComputedStyle(el);
	  width += parseInt(style.marginLeft) + parseInt(style.marginRight);
	  return width;
	};
	
	exports.outerWidth = outerWidth;

/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Carousel", {
	  enumerable: true,
	  get: function get() {
	    return _Carousel.default;
	  }
	});
	Object.defineProperty(exports, "Thumbs", {
	  enumerable: true,
	  get: function get() {
	    return _Thumbs.default;
	  }
	});
	
	var _Carousel = _interopRequireDefault(__webpack_require__(186));
	
	var _Thumbs = _interopRequireDefault(__webpack_require__(100));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 189:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _default = function _default() {
	  return document;
	};
	
	exports.default = _default;

/***/ }),

/***/ 102:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _default = function _default() {
	  return window;
	};
	
	exports.default = _default;

/***/ }),

/***/ 161:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 958:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/seo-hero.c748deba.png";

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _lodash = __webpack_require__(24);
	
	var _whistle = __webpack_require__(44);
	
	var _Button = __webpack_require__(12);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CategoryContainer = /*#__PURE__*/(0, _reactEmotion2.default)('ul', {
	  target: 'eko4fiy0'
	})('display:flex;flex-wrap:wrap;padding:1rem;background:#F8F8F8;@media (min-width:800px){display:flex;align-items:center;justify-content:center;padding:2rem;}');
	
	var CategoryTab = /*#__PURE__*/(0, _reactEmotion2.default)('li', {
	  target: 'eko4fiy1'
	})('list-style-type:none;margin-right:.5rem;a{font-size:0.8rem;padding:0.5rem 1rem;}@media (min-width:800px){a{font-size:1rem;padding:1rem;}}');
	
	var renderCategories = function renderCategories(root, categories) {
	  return categories.sort(function (a, b) {
	    return a.totalCount > b.totalCount ? -1 : 1;
	  }).slice(0, 10).map(function (cat, i) {
	    return _react2.default.createElement(
	      CategoryTab,
	      { key: i },
	      _react2.default.createElement(
	        _Button2.default,
	        { flat: true, to: '/' + root + '/' + (0, _whistle.createLink)(cat.fieldValue) + '/' },
	        cat.fieldValue
	      )
	    );
	  });
	};
	
	var filterByCategroy = function filterByCategroy(categories, input) {
	  if (categories && input) {
	    return (0, _lodash.filter)(categories, function (cat) {
	      return cat.description.indexOf(input) > -1 || cat.title.indexOf(input) > -1;
	    });
	  } else {
	    return categories;
	  }
	};
	
	var CategoryList = function (_React$Component) {
	  _inherits(CategoryList, _React$Component);
	
	  function CategoryList(props) {
	    _classCallCheck(this, CategoryList);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      search: ''
	    };
	    return _this;
	  }
	
	  CategoryList.prototype.searchKeyword = function searchKeyword(search) {
	    return this.setState({ search: search });
	  };
	
	  CategoryList.prototype.render = function render() {
	    return _react2.default.createElement(
	      CategoryContainer,
	      null,
	      _react2.default.createElement(
	        CategoryTab,
	        null,
	        _react2.default.createElement(
	          _Button2.default,
	          { flat: true, to: '/' + this.props.root },
	          'All'
	        )
	      ),
	      renderCategories(this.props.root, filterByCategroy(this.props.categories, this.state.search))
	    );
	  };
	
	  return CategoryList;
	}(_react2.default.Component);
	
	exports.default = CategoryList;
	module.exports = exports['default'];

/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _emotion = __webpack_require__(6);
	
	__webpack_require__(161);
	
	var _reactResponsiveCarousel = __webpack_require__(188);
	
	var _reactHelmet = __webpack_require__(20);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _categoryList = __webpack_require__(86);
	
	var _categoryList2 = _interopRequireDefault(_categoryList);
	
	var _Section = __webpack_require__(13);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Button = __webpack_require__(12);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _twoCol = __webpack_require__(21);
	
	var _SectionPreHeader = __webpack_require__(28);
	
	var _SectionPreHeader2 = _interopRequireDefault(_SectionPreHeader);
	
	var _SubHeader = __webpack_require__(18);
	
	var _SubHeader2 = _interopRequireDefault(_SubHeader);
	
	var _CalloutContainer = __webpack_require__(26);
	
	var _CalloutContainer2 = _interopRequireDefault(_CalloutContainer);
	
	var _HubspotFormSection = __webpack_require__(51);
	
	var _HubspotFormSection2 = _interopRequireDefault(_HubspotFormSection);
	
	var _seoHero = __webpack_require__(958);
	
	var _seoHero2 = _interopRequireDefault(_seoHero);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // requires a loader
	
	
	var CarouselClass = /*#__PURE__*/(0, _emotion.css)('li.slide{display:flex;align-items:center;justify-content:center;background-color:transparent;filter:grayscale(1);}');
	
	var PartnerCardList = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1pptmbb0'
	})('display:flex;flex-wrap:wrap;');
	var PartnerCardWrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1pptmbb1'
	})('box-sizing:border-box;flex:1 0 50%;max-width:50%;padding:1rem 0.5rem;@media (min-width:768px){flex:1 0 33%;max-width:33%;}@media (min-width:1200px){flex:1 0 25%;max-width:25%;}');
	
	var PartnerCardContainer = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1pptmbb2'
	})('text-align:center;padding:1rem;background-color:white;box-shadow:0.5rem 0.5rem 0px #18aa7a;border:2px solid #18aa7a;a{font-size:.8rem;padding:.5rem 1rem;}@media (min-width:800px){a{font-size:1.1rem;padding:1rem 3rem;}}');
	
	var PartnerLogoContainer = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1pptmbb3'
	})('height:100px;align-items:center;display:flex;justify-content:center;padding:1rem;@media (min-width:800px){height:200px;}');
	
	var PartnerLogo = /*#__PURE__*/(0, _reactEmotion2.default)('img', {
	  target: 'e1pptmbb4'
	})('width:100%;width:auto;max-height:100px;max-width:100px;@media (min-width:800px){max-height:250px;max-width:200px;}');
	
	var PartnerCard = function PartnerCard(props) {
	  return _react2.default.createElement(
	    PartnerCardWrapper,
	    null,
	    _react2.default.createElement(
	      PartnerCardContainer,
	      null,
	      _react2.default.createElement(
	        PartnerLogoContainer,
	        null,
	        _react2.default.createElement(PartnerLogo, { src: props.logo, alt: props.partnerName })
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        { icon: true, flat: true, to: props.slug },
	        'Read More'
	      )
	    )
	  );
	};
	
	var IntegrationsPage = function (_React$Component) {
	  _inherits(IntegrationsPage, _React$Component);
	
	  function IntegrationsPage(props) {
	    _classCallCheck(this, IntegrationsPage);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  IntegrationsPage.prototype.render = function render() {
	    console.log(this.props.data);
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: '#1 PMS Integration',
	        meta: [{ name: 'og:title', content: 'Whistle Integrations' }, { name: 'description', content: 'Integrates in just 24 hours and is 100% cloud based.' }, { name: 'og:description', content: 'Integrates in just 24 hours and is 100% cloud based.' }, { name: 'og:image', content: _seoHero2.default }, { name: 'og:type', content: "website" }, { name: 'og:locale', content: "en_US" }]
	      }),
	      _react2.default.createElement(
	        _twoCol.TwoCol,
	        null,
	        _react2.default.createElement(
	          _twoCol.LeftCol,
	          { bgColor: '#18aa7a', skew: true, color: '#fff' },
	          _react2.default.createElement(
	            _SectionPreHeader2.default,
	            null,
	            'Integrations'
	          ),
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Whistle\'s',
	            _react2.default.createElement('br', null),
	            'Powerful',
	            _react2.default.createElement('br', null),
	            'Partnerships'
	          ),
	          _react2.default.createElement(
	            _SubHeader2.default,
	            null,
	            'Whistle works seamlessly',
	            _react2.default.createElement('br', null),
	            ' with your Property Management',
	            _react2.default.createElement('br', null),
	            ' System and can integrate typically',
	            _react2.default.createElement('br', null),
	            ' within one business day.'
	          ),
	          _react2.default.createElement(
	            _CalloutContainer2.default,
	            { align: 'left' },
	            _react2.default.createElement(
	              _Button2.default,
	              { secondary: true, to: '/schedule', icon: true },
	              'Book A Demo'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _twoCol.RightCol,
	          null,
	          _react2.default.createElement(
	            _reactResponsiveCarousel.Carousel,
	            {
	              showArrows: false,
	              showIndicators: false,
	              showThumbs: false,
	              showStatus: false,
	              className: CarouselClass,
	              infiniteLoop: true,
	              autoPlay: function autoPlay() {
	                return true;
	              },
	              interval: 2000,
	              transitionTime: 500
	            },
	            this.props.data.pms.edges.map(function (partner) {
	              return _react2.default.createElement(
	                'div',
	                { key: partner.node.id },
	                _react2.default.createElement('img', {
	                  src: partner.node.frontmatter.logo,
	                  alt: partner.node.frontmatter.title,
	                  title: partner.node.frontmatter.title,
	                  loading: 'lazy'
	                })
	              );
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _Section2.default,
	        { light: true },
	        _react2.default.createElement(_categoryList2.default, {
	          root: 'integrations',
	          categories: this.props.data.categories.group
	        }),
	        _react2.default.createElement(
	          PartnerCardList,
	          null,
	          this.props.data.pms.edges.map(function (partner) {
	            return _react2.default.createElement(PartnerCard, {
	              key: partner.node.id,
	              title: partner.node.frontmatter.title,
	              logo: partner.node.frontmatter.logo,
	              slug: partner.node.fields.slug
	            });
	          })
	        )
	      ),
	      _react2.default.createElement(_HubspotFormSection2.default, {
	        id: 'book-demo',
	        formId: '7d86c04f-e98e-42eb-ae79-ff2b14c7605a',
	        trackingId: ("AW-844932343/Jf_qCLeXzeYBEPfJ8pID")
	      })
	    );
	  };
	
	  return IntegrationsPage;
	}(_react2.default.Component);
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = IntegrationsPage;

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.addComma = exports.createLink = exports.blogItemFormat = exports.blogFormat = undefined;
	
	var _lodash = __webpack_require__(24);
	
	var blogFormat = exports.blogFormat = function blogFormat(data) {
	  var format = {};
	  if (data) {
	    var markdownRemark = data.markdownRemark;
	
	    format = markdownRemark.frontmatter;
	    format.allCategories = data.categories.group;
	    format.html = markdownRemark.html;
	  }
	  return format;
	};
	
	var blogItemFormat = exports.blogItemFormat = function blogItemFormat(data) {
	  var format = {
	    categories: [],
	    posts: []
	  };
	  if (data && data.posts) {
	    if (data.categories.group) {
	      format.categories = data.categories.group;
	    }
	    if (data.posts.edges.length) format.posts = data.posts.edges.map(function (g) {
	      if (g.node && g.node.fields && g.node.fields.slug) {
	        g.node.frontmatter.slug = g.node.fields.slug;
	      }
	      if (g.node && g.node.frontmatter) {
	        return g.node.frontmatter;
	      }
	      return null;
	    });
	  }
	  return format;
	};
	
	var createLink = exports.createLink = function createLink(value) {
	  var link = "";
	  if (value) {
	    link = value.toLowerCase().split(" ").join("-");
	  }
	  return (0, _lodash.kebabCase)(link);
	};
	
	var addComma = exports.addComma = function addComma(arr, index) {
	  var arrayLength = arr.length;
	  if (arr.length === 1 || arrayLength === index + 1) {
	    return null;
	  }
	  if (arrayLength - 1 === index + 1) {
	    return ' and ';
	  }
	  return ", ";
	};

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-integrations-js-4336d962513c547bc357.js